import type { FC } from "react";
import clsx from "clsx";
import type { FieldMetadata } from "node_modules/@conform-to/react/context";

interface EditorTitleInputProps {
  setIsDirty: (isDirty: boolean) => void;
  title: FieldMetadata;
  titleInputControl: any;
  goNext: () => void;
  goPrev?: () => void;
  isTitle?: boolean;
  titleRef: React.RefObject<HTMLTextAreaElement>;
}

const EditorTitleInput: FC<
  EditorTitleInputProps
> = ({
  title,
  titleInputControl,
  setIsDirty,
  goNext,
  goPrev,
  titleRef,
  isTitle = false,
}) => {
  /*   const titleRef =
    useRef<HTMLTextAreaElement>(null);
 */
  return (
    <textarea
      ref={titleRef}
      className={clsx(
        "py-20",
        "w-full",
        "focus:outline-none",
        isTitle && "text-32",
        isTitle && "text-18",
        "resize-none",
        "placeholder:text-gray-400",
        "font-bold",
      )}
      //{...getTextareaProps(title, {})}
      rows={isTitle ? 1 : 2}
      placeholder={isTitle ? "タイトル" : "概要"}
      name={title.name}
      value={titleInputControl.value}
      onFocus={titleInputControl.focus}
      onBlur={titleInputControl.blur}
      onChange={(e) => {
        //改行があったらなくす
        setIsDirty(true);
        const isBreak =
          e.target.value.match(/\n/g);
        if (isBreak) {
          goNext();
        }
        const value = e.target.value.replace(
          /\n/g,
          "",
        );
        titleInputControl.change(value);
      }}
      onKeyDown={(event) => {
        if (event.key === "ArrowUp") {
          event.preventDefault();
          goPrev && goPrev();
        }
        const isSelectLast =
          titleRef.current?.selectionStart ===
          titleRef.current?.value.length;

        console.log(
          "titleRef.current:",
          titleRef.current,
        );
        console.log(
          "titleRef.current?.selectionEnd:",
          titleRef.current?.selectionEnd,
        );
        if (
          titleRef.current?.selectionStart ===
            0 &&
          event.key === "Backspace" &&
          titleRef.current?.selectionEnd === 0
        ) {
          goPrev && goPrev();
        }

        if (
          titleRef.current?.selectionStart ===
            0 &&
          event.key === "ArrowLeft"
        ) {
          goPrev && goPrev();
        }

        if (
          event.key === "ArrowRight" &&
          isSelectLast
        ) {
          goNext();
        }
        if (event.key === "ArrowDown") {
          event.preventDefault();
          goNext();
        }
      }}
    />
  );
};

export default EditorTitleInput;
